// extracted by mini-css-extract-plugin
export default {"aside":"ObjectsAside_aside__TDbJe"};